import styles from "../index.module.less"
import { classModuleGenerator } from "@/utils"
import teacerInner from "@/assets/images/teacher-inner.png"
const classnames = classModuleGenerator(styles)

function Teacher(props) {
  return (
    <section className={styles["teacher-container"]}>
      <h3 className="section__title">严选师资</h3>
      <div className={styles["teacher-content"]}>
        <div className={classnames("teacher-inner")}>
          <img src={teacerInner} alt="" />
          <ul className={classnames("teacher-toplist")}>
            <li>
              <span>严格筛选</span>教师资质
            </li>
            <li>
              精细培养<span>教师能力</span>
            </li>
            <li>
              定期考核<span>教学质量</span>
            </li>
          </ul>
          <ul>
            <li></li>
          </ul>
          <ul className={classnames("teacher-bottomlist", "clearfix")}>
            <li>
              <span>300+</span>实力师资团队
            </li>
            <li>
              <span>100%</span>通过教师资质认证
            </li>
            <li>拥有多年教学经验 </li>
            <li>
              <span>经历200w+*</span>学生家长的检验
            </li>
          </ul>
        </div>
      </div>
    </section>
  )
}

export default Teacher
